import { Injectable } from "@angular/core";
import { DatePipe, Location } from "@angular/common";
import { Router } from "@angular/router";

@Injectable()
export class HelperService {
  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private location: Location
  ) {}

  /**
   *
   * @param temEntities : input form database
   * @param valueKey : value column name
   * @param labelKey : label column name
   * @return output array
   *
   * */
  setSelect2DropDownOptions(temEntities, valueKey, labelKey) {
    var output = [];
    temEntities.forEach(function (value) {
      var tmpObj: any = {
        value: value[valueKey],
        label: value[labelKey]
      };
      output.push(tmpObj);
    });
    return output;
  }

  setSelect2DropDownOptionsJourneyDriver(
    temEntities,
    valueKey,
    labelKey,
    labelKey2
  ) {
    var output = [];
    temEntities.forEach(function (value) {
      var tmpObj: any = {
        value: value[valueKey],
        label: value[labelKey],
        label2: value[labelKey2],
      };
      output.push(tmpObj);
    });
    return output;
  }

  go(url) {
    this.router.navigate([url]);
  }

  goNewTab(url) {
    this.router.navigate([]).then((result) => {
      window.open(url, "_blank");
    });
  }

  goNextTab(url) {
    window.open("#/" + url, "_blank");
  }

  setSelectedValue(value) {
    if (Object.prototype.toString.call(value) !== "[object Array]") {
      if (value !== "" || value != null) {
        value = [+value];
      } else {
        value = [];
      }
    }
    return value;
  }

  setSelect2DropDownOptionsConcatLabel(
    temEntities,
    valueKey,
    labelKey1,
    labelKey2
  ) {
    var output = [];
    temEntities.forEach(function (value) {
      var tmpObj: any = {
        value: value[valueKey],
        label: value[labelKey1] + " - " + value[labelKey2],
      };
      output.push(tmpObj);
    });
    return output;
  }

  setSelect2DropDownOptionsConcatLabelWithExtraValue(
    temEntities,
    valueKey,
    valueKey2,
    labelKey1,
    labelKey2
  ) {
    var output = [];
    temEntities.forEach(function (value) {
      var tmpObj: any = {
        value: value[valueKey],
        value2: value[valueKey2],
        label: value[labelKey1] + " - " + value[labelKey2],
      };
      output.push(tmpObj);
    });
    return output;
  }

  setSelect2DropDownOptionsConcatLabelThree(
    temEntities,
    valueKey,
    labelKey1,
    labelKey2,
    labelKey3
  ) {
    var output = [];
    temEntities.forEach(function (value) {
      var tmpObj: any = {
        value: value[valueKey],
        label:
          value[labelKey1] +
          " | " +
          value[labelKey2] +
          " | " +
          value[labelKey3],
      };
      output.push(tmpObj);
    });
    return output;
  }

  setSelect2DropDownOptionsConcatLabelItems(
    temEntities,
    valueKey,
    labelKey1,
    labelKey2,
    labelKey3
  ) {
    var output = [];
    temEntities.forEach(function (value) {
      var partNo = "";

      if (value[labelKey3]) {
        partNo = " - " + value[labelKey3];
      }

      var tmpObj: any = {
        value: value[valueKey],
        label: value[labelKey1] + " - " + value[labelKey2] + partNo,
      };
      output.push(tmpObj);
    });
    return output;
  }

  indexOrder(value, orderCondition, totalRec) {
    let finalIndex;
    if (orderCondition === "asc") {
      finalIndex = +totalRec - +value;
      return finalIndex * 1 + 1;
    }
    return value;
  }

  getRouteDataByKey(currentRoute, key) {
    var data = currentRoute.data;
    return data[key];
  }

  getRouterQueryParam(currentRoute, key) {
    const data = currentRoute.queryParams;
    return data[key];
  }

  getToken(): string {
    return localStorage.getItem("access_token");
  }

  // getSelectedCompanyId(): string {
  //   return localStorage.getItem("selectedCompany");
  // }

  // getSelectedCompanyId(): string {
  //   return sessionStorage.getItem("selectedCompany");
  // }

  getSelectedCompanyId(): string {
    const selectedCompanyInSession = sessionStorage.getItem("selectedCompany");
    if (selectedCompanyInSession) {
      return selectedCompanyInSession;
    } else {
      const selectedCompanyInLocalStorage = localStorage.getItem("selectedCompany");
      return selectedCompanyInLocalStorage;
    }
  }
  



  getuserID(): string {
    return sessionStorage.getItem("uid");
  }

  transformDate(date) {
    if (
      date === undefined ||
      date === null ||
      date === "" ||
      date == "0000-00-00 00:00:00"
    ) {
      return null;
    } else {
      const d = new Date(date);
      return this.datePipe.transform(d, "MM/dd/yyyy");
    }
  }

  getMaximum(array): number {
    var max = 0;
    array.forEach(function (value) {
      if (value > max) {
        max = value;
      }
    });

    return max;
  }

  print(id) {
    let printContents, popupWin;
    printContents = document.getElementById(id).innerHTML;
    popupWin = window.open("", "_blank", "top=0,left=0,height=100%,width=auto");
    popupWin.document.open();
    popupWin.document.write(`
              <html>
                <head>
                  <title>Print tab</title>
                  <style>
                  //........Customized style.......
                  </style>
                </head>
               <body onload="window.print();window.close()">${printContents}</body>
              </html>`);
    popupWin.document.close();
  }

  goBack() {
    this.location.back();
  }

  formatDate(date) {
    return this.datePipe.transform(date);
  }

  formatDateTime(date, format) {
    return this.datePipe.transform(date, format);
  }

  //get sum of a column in a record
  getSum(data, column): number {
    let sum = 0;
    for (let i = 0; i < data.length; i++) {
      sum += data[i][column];
    }
    return sum;
  }

  // custome decimal place function
  decimalPlace(decimalPlace) {
    let decimalPlaces = "1." + decimalPlace + "-" + decimalPlace;
    return decimalPlaces;
  }

  setMultipleselectDropDown(temEntities, valueKey, labelKey, labelKey1 = "") {
    const output = [];
    let label;

    temEntities.forEach(function (value) {
      if (value[labelKey] == null) {
        value[labelKey] = " ";
      }

      if (labelKey1 != "") {
        label = value[labelKey] + " | " + value[labelKey1];
      } else {
        label = value[labelKey];
      }

      const tmpObj: any = {
        id: value[valueKey],
        itemName: label,
      };

      output.push(tmpObj);
    });
    return output;
  }

  setMultipleselectDropDown2(temEntities, valueKey, labelKey, labelKey1 = "") {
    const output = [];
    let label;
    let label2;

    temEntities.forEach(function (value) {
      if (value[labelKey] == null) {
        value[labelKey] = " ";
      }

      label = value[labelKey];
      label2  = value[labelKey1]

      const tmpObj: any = {
        id: value[valueKey],
        itemName: label,
        label2: label2
      };

      output.push(tmpObj);
    });
    return output;
  }

  serverSideError422(validationErrors) {
    var htmlErrorMessage = "";
    for (let prop in validationErrors) {
      htmlErrorMessage +=
        "<span class='text-danger'>" +
        validationErrors[prop][0] +
        "<br></span>";
    }
    return htmlErrorMessage;
  }

  serverSideErrorFromArray(errors) {
    let htmlErrorMessage = "";
    for (const prop in errors) {
      htmlErrorMessage +=
        "<span class='text-danger'>" + errors[prop] + "<br></span>";
    }
    return htmlErrorMessage;
  }

  public cloneObject(obj) {
    if (null == obj || "object" != typeof obj) {
      return obj;
    }
    var copy = obj.constructor();
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) {
        copy[attr] = obj[attr];
      }
    }
    return copy;
  }

  goToProfile() {
    let url = "configuration/profile";
    if (+this.getSelectedCompanyId() == 3) {
      url = "configuration/profile-alkhoraye";
    }else if(+this.getSelectedCompanyId() == 7){
      url = "configuration/profile-nesr";
    }
    this.go(url);
  }

  public readFile(file: File): Promise<string | ArrayBuffer> {
    return new Promise<string | ArrayBuffer>((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        return resolve((e.target as FileReader).result);
      };

      reader.onerror = (e) => {
        console.error(`FileReader failed on file ${file.name}.`);
        return reject(null);
      };

      if (!file) {
        console.error("No file to read.");
        return reject(null);
      }

      reader.readAsDataURL(file);
    });
  }

  public getAvailableLang() {
    return [
      { id: 1, label: "en", icon: "us" },
      // { id: 2, label: "es", icon: "es" },
      { id: 3, label: "ar", icon: "sa" },
      { id: 4, label: "hi", icon: "in" },
      { id: 5, label: "ur", icon: "pk" },
    ];
  }

  public setDefaultColumnObject(columnArray) {
    const defaultColumn = {};
    columnArray.forEach((element) => {
      defaultColumn[element] = { value: false };
    });
    return defaultColumn;
  }

  public incidentsIdChangeToInt(data) {
    for (let i = 0; i < data.length; i++) {
      data[i].id = +data[i].id;
    }
    return data;
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/helper.service.ts